import React from 'react';
import { useSecuritySettings } from '../../hooks/useAuditLog';
import { Card } from '../../components/ui/Card';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { SecuritySettingsForm } from '../../components/security/SecuritySettingsForm';
import { SessionManager } from '../../components/security/SessionManager';
import { ShieldCheck } from 'lucide-react';

export const SecuritySettingsPage: React.FC = () => {
  const { settings, sessions, isLoading, isSaving, saveSettings, revokeSession } = useSecuritySettings();

  if (isLoading || !settings) return <LoadingSpinner size="lg" text="Loading Security Settings..." />;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <ShieldCheck className="w-5 h-5 text-sky-400" />
          Security Settings
        </h3>
        <p className="text-xs text-slate-400">Configure password policy, session behaviour, and token lifetimes</p>
      </div>

      <SecuritySettingsForm settings={settings} isSaving={isSaving} onSave={saveSettings} />

      <Card title="Active Sessions" subtitle="Currently signed-in users across devices">
        <SessionManager sessions={sessions} onRevoke={revokeSession} />
      </Card>
    </div>
  );
};
